import { STORE } from "../../../data/storeData";

// モバイル専用の固定CTAバー（画面下部）
// header の3ボタン（メニュー／Googleマップ／店舗情報）と同じ導線を、
// スマホでも常に押せるようにするためのバー。
// - タップ領域は44px以上
// - コンテンツやフッターを隠さないよう、page側で下部余白を確保
export default function MobileCTABar() {
  return (
    <nav
      aria-label="クイックアクセス"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50 border-t border-background-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid grid-cols-3">
        <a
          href="#menu"
          className="flex flex-col items-center justify-center gap-0.5 min-h-[56px] py-2 text-primary-700 font-heading font-bold text-[11px] cursor-pointer active:bg-background-100"
        >
          <i className="ri-restaurant-line text-lg" aria-hidden="true"></i>
          メニュー
        </a>
        <a
          href={STORE.googleMapsSearchUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-0.5 min-h-[56px] py-2 text-primary-700 font-heading font-bold text-[11px] cursor-pointer active:bg-background-100 border-x border-background-200"
        >
          <i className="ri-map-2-line text-lg" aria-hidden="true"></i>
          Googleマップ
        </a>
        <a
          href="#store"
          className="flex flex-col items-center justify-center gap-0.5 min-h-[56px] py-2 bg-primary-600 text-background-50 font-heading font-bold text-[11px] cursor-pointer active:bg-primary-700"
        >
          <i className="ri-anchor-line text-lg" aria-hidden="true"></i>
          店舗情報
        </a>
      </div>
    </nav>
  );
}
